<template>
  <div class="navWrapper">
    <el-collapse-transition>
      <el-row v-if="isActive" id="menu" :class="{ active: isActive }">
        <el-menu mode="horizontal" @select="handleSelect" :router="true">
          <slot name="toggle-content"></slot>
        </el-menu>
      </el-row>
    </el-collapse-transition>
    <div id="toggle" @click="select()"> <!-- icon for small screen -->
      <div class="span" id="top" :class="{ active: isActive }"></div>
      <div class="span" id="middle" :class="{ active: isActive }"></div>
      <div class="span" id="bottom" :class="{ active: isActive }"></div>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },

  data() {
    return {
      activeIndex: '/hello',
      isActive: false
    }
  },
  methods: {
    handleSelect(key, keyPath) {
    },
    select: function() {
      this.isActive = !this.isActive;
    }
  }
}
</script>

<style scoped>
  #toggle {
    position: absolute;
    right: 20px;
    top: 2px;
    z-index: 999;
    width: 20px;
    height: 30px;
    cursor: pointer;
    float: right;
    transition: all .3s ease-out;
    visibility: visible;
    opacity: 1;
    margin-top: 6px;
  }

  #toggle .span {
    border-radius: 10px;
    background: black;
    height: 4px;
    transition: all .3s ease-out;
    backface-visibility: visible;
    visibility: visible;
    opacity: 1;
    margin: 3px 0;
  }

  #top.span.active {
    transform: rotate(45deg) translateX(3px) translateY(5px);
  }

  #middle.span.active {
    opacity: 0;
  }

  #bottom.span.active {
    transform: rotate(-45deg) translateX(5px) translateY(-7px);
  }

  #menu {
    width: 100%;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 9999;
  }

  #menu.active {
    margin-top: 40px;
    visibility: visible;
    opacity: 1;
  }

</style>